export default {
  AD: 'Andorra',
  AF: 'Afghanistan',
  EG: 'Ägypten',
  EH: 'Westsahara',
  FO: 'Färöer Inseln',
  GA: 'Gabun',
  GD: 'Grenada',
  GI: 'Gibraltar',
  GM: 'Gambia',
  AG: 'Antigua und Barbuda',
  AI: 'Angilla',
  AL: 'Albanien',
  AN: 'Niederländische Antillen',
  AO: 'Angola',
  AQ: 'Antarktis',
  AR: 'Argentinien',
  AU: 'Australien',
  AW: 'Aruba',
  AZ: 'Aserbaidschan',
  BA: 'Bosnien und Herzegowina',
  BB: 'Barbados',
  BF: 'Burkina Faso',
  BG: 'Bulgarien',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BM: 'Bermudas',
  BS: 'Bahamas',
  BV: 'Bouvetinsel',
  BW: 'Botswana',
  BZ: 'Belize',
  CA: 'Kanada',
  CF: 'Zentralafrika',
  CG: 'Kongo',
  CI: 'Elfenbeinküste',
  CK: 'Cookinseln',
  CN: 'China',
  CU: 'Kuba',
  CV: 'Kap Verde',
  DE: 'Deutschland',
  EC: 'Ecuador',
  GR: 'Griechenland',
  IR: 'Iran',
  IT: 'Italien',
  JM: 'Jamaika',
  JO: 'Jordanien',
  JP: 'Japan',
  KE: 'Kenia',
  KM: 'Komoren',
  KP: 'Nord Korea',
  KR: 'Südkorea',
  LB: 'Libanon',
  LS: 'Lesotho',
  LU: 'Luxemburg',
  LV: 'Lettland',
  MD: 'Moldawien',
  GU: 'Guam',
  HK: 'Hongkong',
  HM: 'Heard-Inseln und Mc-Donald-Inseln',
  HT: 'Haiti',
  MK: 'Mazedonien',
  ML: 'Mali',
  MN: 'Mongolei',
  HU: 'Ungarn',
  ID: 'Indonesien',
  IE: 'Irland',
  IL: 'Israel',
  IN: 'Indien',
  IQ: 'Irak',
  MT: 'Malta',
  MV: 'Malediven',
  MX: 'Mexiko',
  NC: 'Neu-Kaledonien',
  NI: 'Nicaragua',
  NZ: 'Neuseeland',
  PE: 'Peru',
  PL: 'Polen',
  PT: 'Portugal',
  PW: 'Palau',
  CR: 'Costa Rica',
  CZ: 'Tschechien',
  DZ: 'Algerien',
  ET: 'Äthiopien',
  FR: 'Frankreich',
  RO: 'Rumänien',
  RU: 'Russland',
  SA: 'Saudi-Arabien',
  SB: 'Salomon-Inseln',
  SC: 'Seychellen',
  SD: 'Sudan',
  SE: 'Schweden',
  SG: 'Singapur',
  SI: 'Slowenien',
  SJ: 'Spitzbergen und Jan Mayen',
  SK: 'Slowakei',
  SL: 'Sierra Leone',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'Sao Tome und Principe',
  SV: 'El Salvador',
  SZ: 'Swasiland',
  TC: 'Turks- und Caicosinseln',
  TD: 'Tschad',
  TF: 'Südfranzösische Territorien',
  TG: 'Gehen',
  TH: 'Thailand',
  TK: 'Tokelau',
  TM: 'Turkmenistan',
  TN: 'Tunesien',
  TP: 'Osttimor',
  TT: 'Trinidad und Tobago',
  UA: 'Ukraine',
  US: 'Vereinigte Staaten',
  UZ: 'Usbekistan',
  VA: 'Vatikan',
  VE: 'Venezuela',
  VG: 'Britische Jungferninseln',
  VU: 'Vanuatu',
  YE: 'Jemen',
  YT: 'Mayotte',
  YU: 'Jugoslawien',
  ZA: 'Südafrika',
  ZW: 'Zimbabwe',
  GB: 'Vereinigtes Königreich',
  BO: 'Bolivien',
  BT: 'Bhutan',
  BY: 'Weißrussland',
  CC: 'Kokos-(Keeling-)Inseln',
  CL: 'Chile',
  CO: 'Kolumbien',
  TW: 'Taiwan,China',
  CY: 'Zypern',
  DK: 'Dänemark',
  DO: 'Dominikanische Republik',
  ES: 'Spanien',
  FI: 'Finnland',
  FK: 'Malvinas-Inseln (Falklandinseln)',
  GE: 'Georgia',
  GL: 'Grönland',
  GN: 'Guinea',
  GS: 'Südgeorgien und Südliche Sandwichinseln',
  KW: 'Kuwait',
  KZ: 'Kasachstan',
  LT: 'Litauen',
  LY: 'Libyen',
  MH: 'Marshallinseln',
  MO: 'Macau',
  MU: 'Mauritius',
  MY: 'Malaysia',
  NA: 'Namibia',
  NU: 'Niue',
  OM: 'Oman',
  PK: 'Pakistan',
  PR: 'Puerto-Rico',
  AT: 'Österreich',
  BD: 'Bangladesch',
  CH: 'Schweiz',
  CS: 'Weihnachtsinsel',
  FM: 'Mikronesien',
  IO: 'Britisches Territorium des Indischen Ozeans',
  KI: 'Kiribati',
  LC: 'Heilige Lucia',
  MA: 'Marokko',
  MM: 'Myanmar',
  MS: 'Montserrat',
  NG: 'Nigeria',
  PH: 'Philippinen',
  RE: 'Wiedervereinigung',
  WS: 'West-Samoa',
  AE: 'Vereinigte Arabische Emirate',
  AS: 'Amerikanischen Samoa-Inseln',
  BE: 'Belgien',
  BN: 'Brunei Darussalam',
  CM: 'Kamerun',
  DJ: 'Dschibuti',
  ER: 'Eritrea',
  GF: 'Französisch-Guayana',
  GW: 'Guine-Bissau',
  HR: 'Kroatien',
  IS: 'Island',
  KH: 'Kambodscha',
  KY: 'Cayman Inseln',
  LR: 'Liberia',
  MQ: 'Martinique',
  MZ: 'Mosambik',
  PA: 'Panama',
  PN: 'Pitcairn-Inseln-Gruppe',
  RW: 'Ruanda',
  SH: 'Heilige Helena',
  SM: 'San Marion',
  SY: 'Syrien',
  TJ: 'Tadschikistan',
  TZ: 'Tansania',
  EE: 'Estland',
  LI: 'Liechtenstein',
  NF: 'Norfolkinsel',
  PY: 'Paraguay',
  GP: 'Guadeloupe',
  UM: 'Miscella-neous Pac der Vereinigten Staaten',
  NP: 'Nepal',
  PM: 'St. Pierre und Miquelon',
  GQ: 'Äquatorialguinea',
  GY: 'Guyana',
  KG: 'Kirgistan',
  KN: 'St. Kitts und Nevis',
  LA: 'Lao',
  LK: 'Sri Lanka',
  MC: 'Monaco',
  MG: 'Madagaskar',
  MR: 'Mauretanien',
  MW: 'Malawi',
  NE: 'Niger',
  NO: 'Norwegen',
  NR: 'Nauru',
  PG: 'Papua Neu-Guinea',
  PS: 'Palästina',
  QA: 'Katar',
  RS: 'Serbien',
  MP: 'Nördliche Marianen',
  NL: 'Niederlande',
  PF: 'Französisch Polynesien',
  AM: 'Armenien',
  BR: 'Brasilien',
  DM: 'Dominika',
  HN: 'Honduras',
  TO: 'Tonga',
  TR: 'Truthahn',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UY: 'Uruguay',
  VC: 'St. Vincent und die Grenadinen',
  VI: 'United States Virgin Islands',
  WF: 'Wallis- und Futuna-Inseln',
  ZM: 'Sambia',
  FJ: 'Fidschi',
  GH: 'Ghana',
  GT: 'Guatemala',
  VN: 'Vietnam',
  ZR: 'Zaire',
};
